import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ProdottiPage = () => {
  const categories = [
    {
      title: 'Computer e Notebook',
      description: 'Laptop professionali, desktop, workstation e mini PC per ogni esigenza aziendale',
      icon: 'ri-computer-line',
      color: 'blue',
      products: ['Laptop Business', 'Desktop Tower', 'Workstation', 'Mini PC', 'All-in-One'],
      image: 'https://public.readdy.ai/ai/img_res/7193c6e518579e0c520edcf7ff203cc1.jpg'
    },
    {
      title: 'Smartphone e Tablet',
      description: 'Dispositivi mobile di ultima generazione per comunicazione e produttività',
      icon: 'ri-smartphone-line',
      color: 'green',
      products: ['Smartphone Android', 'iPhone', 'Tablet Android', 'iPad', 'Accessori Mobile'],
      image: 'https://readdy.ai/api/search-image?query=latest%20smartphone%20standing%20vertically%20on%20clean%20surface%20modern%20mobile%20phone%20with%20large%20touchscreen%20premium%20device%20with%20sleek%20design%20minimalist%20product%20shot%20neutral%20white%20background%20emphasizing%20mobile%20technology%20commercial%20photography&width=400&height=500&seq=amaca-prod-phone-010&orientation=portrait'
    },
    {
      title: 'Monitor e Display',
      description: 'Monitor professionali, gaming e per grafica con tecnologie avanzate',
      icon: 'ri-tv-line',
      color: 'purple',
      products: ['Monitor Business', 'Monitor Gaming', 'Monitor 4K', 'Monitor Curvi', 'Supporti Monitor'],
      image: 'https://readdy.ai/api/search-image?query=professional%20computer%20monitor%20display%20on%20desk%20modern%20widescreen%20lcd%20screen%20showing%20workspace%20sleek%20monitor%20with%20thin%20bezels%20contemporary%20office%20setup%20clean%20minimalist%20background%20emphasizing%20display%20technology%20commercial%20product%20shot&width=600&height=400&seq=amaca-prod-monitor-011&orientation=landscape'
    },
    {
      title: 'Componenti PC',
      description: 'Processori, schede madri, RAM, storage e componenti per assemblaggio',
      icon: 'ri-cpu-line',
      color: 'red',
      products: ['Processori', 'Schede Madri', 'RAM', 'SSD e HDD', 'Schede Video'],
      image: 'https://readdy.ai/api/search-image?query=computer%20hardware%20components%20including%20processor%20motherboard%20and%20ram%20modules%20arranged%20on%20clean%20surface%20pc%20building%20parts%20with%20visible%20circuits%20and%20chips%20technology%20components%20display%20neutral%20background%20emphasizing%20electronic%20parts&width=600&height=400&seq=amaca-prod-components-012&orientation=landscape'
    },
    {
      title: 'Periferiche',
      description: 'Tastiere, mouse, webcam, cuffie e accessori per computer',
      icon: 'ri-keyboard-line',
      color: 'orange',
      products: ['Tastiere', 'Mouse', 'Webcam', 'Cuffie', 'Speaker'],
      image: 'https://readdy.ai/api/search-image?query=modern%20computer%20keyboard%20and%20wireless%20mouse%20on%20desk%20sleek%20peripheral%20devices%20with%20minimalist%20design%20professional%20office%20accessories%20clean%20workspace%20setup%20neutral%20background%20emphasizing%20input%20devices%20commercial%20product%20photography&width=600&height=400&seq=amaca-prod-peripherals-013&orientation=landscape'
    },
    {
      title: 'Software e Licenze',
      description: 'Sistemi operativi, suite office, antivirus e software professionali',
      icon: 'ri-window-line',
      color: 'indigo',
      products: ['Windows', 'Microsoft Office', 'Antivirus', 'Software Grafica', 'Software Gestionale'],
      image: 'https://readdy.ai/api/search-image?query=software%20license%20boxes%20and%20digital%20product%20cards%20arranged%20professionally%20microsoft%20windows%20and%20office%20packages%20antivirus%20software%20boxes%20clean%20product%20display%20with%20colorful%20packaging%20commercial%20photography%20style%20neutral%20background&width=600&height=400&seq=amaca-prod-software-014&orientation=landscape'
    },
    {
      title: 'Networking',
      description: 'Router, switch, access point e soluzioni per reti aziendali',
      icon: 'ri-router-line',
      color: 'teal',
      products: ['Router', 'Switch', 'Access Point', 'Firewall', 'Cavi di Rete'],
      image: 'https://readdy.ai/api/search-image?query=network%20router%20and%20switch%20equipment%20on%20professional%20setup%20modern%20networking%20devices%20with%20led%20indicators%20enterprise%20grade%20network%20hardware%20clean%20technology%20display%20emphasizing%20connectivity%20equipment%20commercial%20product%20shot&width=600&height=400&seq=amaca-prod-network-015&orientation=landscape'
    },
    {
      title: 'Stampanti e Scanner',
      description: 'Stampanti laser, inkjet, multifunzione e scanner professionali',
      icon: 'ri-printer-line',
      color: 'pink',
      products: ['Stampanti Laser', 'Stampanti Inkjet', 'Multifunzione', 'Scanner', 'Consumabili'],
      image: 'https://readdy.ai/api/search-image?query=modern%20office%20printer%20and%20scanner%20on%20desk%20professional%20multifunction%20device%20sleek%20business%20printer%20with%20paper%20tray%20contemporary%20office%20equipment%20clean%20workspace%20setup%20neutral%20background%20emphasizing%20printing%20technology&width=600&height=400&seq=amaca-prod-printer-016&orientation=landscape'
    },
    {
      title: 'Storage e Backup',
      description: 'Hard disk esterni, NAS, SSD portatili e soluzioni di backup',
      icon: 'ri-hard-drive-line',
      color: 'cyan',
      products: ['Hard Disk Esterni', 'SSD Portatili', 'NAS', 'Pen Drive', 'Memory Card'],
      image: 'https://readdy.ai/api/search-image?query=external%20hard%20drives%20and%20portable%20ssd%20storage%20devices%20arranged%20on%20clean%20surface%20modern%20backup%20solutions%20with%20sleek%20design%20various%20storage%20capacities%20displayed%20neutral%20background%20emphasizing%20data%20storage%20technology%20commercial%20product%20photography&width=600&height=400&seq=amaca-prod-storage-017&orientation=landscape'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors: { [key: string]: { bg: string; text: string; hover: string } } = {
      blue: { bg: 'bg-blue-100', text: 'text-blue-600', hover: 'hover:bg-blue-600' },
      green: { bg: 'bg-green-100', text: 'text-green-600', hover: 'hover:bg-green-600' },
      purple: { bg: 'bg-purple-100', text: 'text-purple-600', hover: 'hover:bg-purple-600' },
      red: { bg: 'bg-red-100', text: 'text-red-600', hover: 'hover:bg-red-600' },
      orange: { bg: 'bg-orange-100', text: 'text-orange-600', hover: 'hover:bg-orange-600' },
      indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600', hover: 'hover:bg-indigo-600' },
      teal: { bg: 'bg-teal-100', text: 'text-teal-600', hover: 'hover:bg-teal-600' },
      pink: { bg: 'bg-pink-100', text: 'text-pink-600', hover: 'hover:bg-pink-600' },
      cyan: { bg: 'bg-cyan-100', text: 'text-cyan-600', hover: 'hover:bg-cyan-600' },
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">I Nostri Prodotti</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Scopri il nostro ampio catalogo di prodotti tecnologici per rivenditori e aziende. Oltre 5000 articoli disponibili con consegne rapide in tutta Italia.
          </p>
        </div>
      </section>
      
      <section className="py-20 bg-white" data-product-shop>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category, index) => {
              const colorClasses = getColorClasses(category.color);
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all border border-gray-200 group"
                >
                  <div className="h-56 overflow-hidden bg-gray-100">
                    <img
                      src={category.image}
                      alt={category.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  
                  <div className="p-6">
                    <div className={`w-14 h-14 ${colorClasses.bg} rounded-full flex items-center justify-center mb-4 ${colorClasses.hover} group-hover:text-white transition-all`}>
                      <i className={`${category.icon} text-2xl ${colorClasses.text} group-hover:text-white transition-colors`}></i>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{category.title}</h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">{category.description}</p>
                    
                    <ul className="space-y-2 mb-6">
                      {category.products.map((product, idx) => (
                        <li key={idx} className="flex items-center text-sm text-gray-700">
                          <i className={`ri-check-line ${colorClasses.text} mr-2`}></i>
                          {product}
                        </li>
                      ))}
                    </ul>
                    
                    <Link
                      to="/contatti"
                      className={`inline-flex items-center ${colorClasses.text} font-semibold hover:underline cursor-pointer`}
                    >
                      Richiedi Informazioni
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Richiedi il Listino Completo</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Contattaci per ricevere il nostro listino prezzi riservato B2B con tutte le categorie di prodotti disponibili e le condizioni commerciali dedicate.
          </p>
          <Link
            to="/contatti"
            className="inline-flex items-center bg-blue-600 text-white px-10 py-4 rounded-xl text-lg font-semibold hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Contattaci Ora
            <i className="ri-arrow-right-line ml-3"></i>
          </Link>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ProdottiPage;
